import {Component, ElementRef, ViewChild} from '@angular/core';
import {MatLegacyTableDataSource as MatTableDataSource} from '@angular/material/legacy-table';
import {PaginatorComponent} from '../../../shared/paginator';
import {MatSort} from '@angular/material/sort';
import {AppLoaderComponent} from '../../../shared/app-loader/app-loader.component';
import {MatLegacyButton as MatButton} from '@angular/material/legacy-button';

@Component({
   selector: 'app-package-list',
   templateUrl: './package-list.component.html',
   styleUrls: ['./package-list.component.css']
})



export class PackageListComponent {
   @ViewChild(PaginatorComponent) paginator: PaginatorComponent;
   @ViewChild(MatSort) sort: MatSort;
   @ViewChild(AppLoaderComponent) loader: AppLoaderComponent;
   @ViewChild('wrapper') wrapper: ElementRef;
   @ViewChild('btnDelSite', {static: true}) public buttonDel: MatButton;
   isLoadingResults = true;
   listPackage = [
      {
         "id": "00001",
         "itemCode": "zdox-item-00001",
         "itemName": "ผู้ใช้งาน {User}",
         "itemType": "ราคาขั้นบันได {Step Price}",
         "unit": "user {s}",
         "price": "0 - 9,000",
         "discountPrice": "0 - 250",
      },
      {
         "id": "00002",
         "itemCode": "zdox-item-00002",
         "itemName": "Advance PDF Viewer",
         "itemType": "ราคาต่อหน่วย {Price Per Item}",
         "unit": "ฟังก์ชัน",
         "price": "500,000",
         "discountPrice": "10%",
      }
   ];
   selectedRowIndex = -1;
   displayedColumns = ['no', 'item_code', 'item_name', 'item_type', 'unit', 'price', 'discount_price', 'menu'];
   dataSource: MatTableDataSource<PackageData>;

   constructor() {
      // This is intentional
   }

   openPackageDialog(isEdit: boolean) {
      // This is intentional
   }
}

export interface PackageData {
   id: number;
   itemCode: string;
   itemName: string;
   itemType: string;
   unit: string;
   price: string;
   discountPrice: string;
}
